






















import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import { UserRole } from "@/types/types";
import { store } from "@/store/store";
import { mapState } from "vuex";

export default Vue.extend({
  components: { StandartCard, LineChart },
  data(): any {
    return {
      datacollection: {},
      colors: ["#6caf8f", "#bc5265"]
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.format_data_labels,
        datasets: this.format_data_dataset
      };
    }
  },
  computed: mapState({
    format_data_labels(): Array<string> {
      return [
        ...new Set(
          store.getters.GET_DEVICE_BY_DAY.map(
            (device) => new Date(device.date).getMonth() + 1 + "/" + new Date(device.date).getDate()
          )
        )
      ];
    },
    format_data_dataset(): Array<any> {
      let datasets: any[] = [];
      let color_index = 0;
      const user_role = store.getters.ROLE_BY_ID[store.getters.LOGGED_USER?.role as string].name;
      let labels = [...new Set(store.getters.GET_DEVICE_BY_DAY.map((device) => device.agence))];
      if (store.getters.GET_VIEW !== "ADMIN" && store.getters.GET_VIEW !== null)
        labels = labels.filter((label) => label === store.getters.GET_VIEW);
      labels.forEach((label) => {
        const agence_name = store.getters.AGENCE_BY_ID[label].name;
        if (agence_name === "Paris" || agence_name === "Lyon") {
          datasets.push({
            label: `Appareils posés à ${store.getters.AGENCE_BY_ID[label].name}`,
            borderColor: this.colors[color_index],
            data: store.getters.GET_DEVICE_BY_DAY.filter((device) => device.agence === label).map(
              (result) => result.device_set
            )
          });
          color_index++;
        }
      });
      if (user_role.toUpperCase() === UserRole.ADMINISTRATOR && store.getters.GET_VIEW === "ADMIN") {
        let result: Array<{ date: string; count: number }> = [];
        store.getters.GET_DEVICE_BY_DAY.forEach((device) => {
          const date = new Date(device.date).getMonth() + 1 + "/" + new Date(device.date).getDate();
          let finded = result.find((r) => r.date === date);
          if (finded) finded.count += device.device_set;
          else result.push({ date: date, count: device.device_set });
        });
        datasets.push({
          label: "Total Appareils posés",
          borderColor: "#f59a2d",
          data: result.map((value) => value.count)
        });
      }
      return datasets;
    },
    view(): string | null {
      return this.$store.state.view;
    }
  }),
  watch: {
    view: {
      handler(): void {
        this.fillData();
      }
    }
  }
});
